import React from "react";
import { Link } from "react-router-dom";
import Seo from "../../../components/public/Seo";
import "../../../styles/legal.css";

export default function LegalIndex() {
  return (
    <>
      <Seo
        title="Legal — Veya"
        description="Legal, privacy, merchant terms, cookie information and licence notices for Veya."
      />

      <main className="legal-page">
        <section className="legal-hero">
          <p className="legal-kicker">Veya Legal</p>
          <h1>Legal, privacy & licence information</h1>
          <p>
            The practical information behind using Veya — including privacy,
            platform terms, merchant responsibilities, cookies, and open-source
            licence notices.
          </p>
        </section>

        <section className="legal-grid">
          <Link to="/legal/privacy" className="legal-tile">
            <span>01</span>
            <h2>Privacy Policy</h2>
            <p>
              How Veya collects, uses, stores and shares personal information,
              including shopper activity, edits, try-on signals and merchant
              account data.
            </p>
          </Link>

          <Link to="/legal/terms" className="legal-tile">
            <span>02</span>
            <h2>Terms of Use</h2>
            <p>
              The rules for using Veya, including account use, product
              information, shopper features and the try-on visualisation
              disclaimer.
            </p>
          </Link>

          <Link to="/legal/merchant-terms" className="legal-tile">
            <span>03</span>
            <h2>Merchant Terms</h2>
            <p>
              Responsibilities for boutiques and merchants using Veya,
              including catalogue accuracy, imagery, insights and customer
              obligations.
            </p>
          </Link>

          <Link to="/legal/cookies" className="legal-tile">
            <span>04</span>
            <h2>Cookies & Analytics</h2>
            <p>
              How Veya may use cookies, local storage, analytics and similar
              technologies to operate and improve the platform.
            </p>
          </Link>

          <Link to="/legal/licenses" className="legal-tile">
            <span>05</span>
            <h2>Licence Notices</h2>
            <p>
              Open-source and third-party software licence information for the
              frontend, backend and supporting services used by Veya.
            </p>
          </Link>
        </section>
      </main>
    </>
  );
}